import React from 'react'
import ReactMapboxGl from 'react-mapbox-gl'
import {accessToken} from '../config.js'
import ChangesContainer from "../containers/Changes";
import {useDispatch} from "react-redux";
import changes from '../redux/changesDuck'
import mapDuck from "../redux/mapDuck";

const Map = ReactMapboxGl(
    {
        accessToken, hash: true})


function Maps(props) {

    const dispatch = useDispatch()

  return (
    <Map
      style="mapbox://styles/mapbox/streets-v9"
      containerStyle={{
        height: "100vh",
        width: "100vw",
      }}
       onStyleLoad={(event)=> dispatch(mapDuck.actions.setBoundingBox(event.getBounds().toArray()))}
        onMoveEnd={ (event)=> dispatch(mapDuck.actions.setBoundingBox(event.getBounds().toArray()))}
        dragRotate={false}

      center={props.center}
      zoom={props.zoom}
    >
        {/*<Source id="source_test" geojsonSource={GEOJSON_SOURCE_OPTIONS}/>*/}
    {/*<GeoJSONLayer data={changeLayerUrl} fillPaint={{'fill-color':'red'}}/>*/}
    <ChangesContainer/>
</Map>
  )
}

export default Maps



// WEBPACK FOOTER //
// ./src/components/Maps.js